import { render, staticRenderFns } from "./_template-indicator-navigator.vue?vue&type=template&id=9f1b2510&scoped=true&"
import script from "./_template-indicator-navigator.vue?vue&type=script&lang=js&"
export * from "./_template-indicator-navigator.vue?vue&type=script&lang=js&"
import style0 from "./_template-indicator-navigator.vue?vue&type=style&index=0&id=9f1b2510&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1b2510",
  null
  
)

export default component.exports